// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format11 } from '../../constants';

/** Oman */
const OM: PhoneNumberData = [968, 'OM', 8, format11];

export default OM;
